import { render, staticRenderFns } from "./UiStepper.vue?vue&type=template&id=381af113&scoped=true&"
import script from "./UiStepper.vue?vue&type=script&lang=ts&"
export * from "./UiStepper.vue?vue&type=script&lang=ts&"
import style0 from "./UiStepper.vue?vue&type=style&index=0&id=381af113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381af113",
  null
  
)

export default component.exports